import { Box, TextField, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { useParams } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Avatar from '@mui/material/Avatar';
import axios from 'axios';
import { Toaster, toast } from 'sonner';
import { useLocation } from 'react-router-dom';

const ResetPassword = () => {
    //const { email, token } = useParams();
    // const [searchParams, setSearchParams] = useSearchParams();
    // const token = decodeURIComponent(searchParams.get('token'));
    // const email = searchParams.get('email');

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const email = searchParams.get('email');

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            alert('Passwords do not match');
            return;
        }

        try {
            const response = await axios.post(apiUrl + '/users/reset-password', {
                email,
                token,
                "newPassword": password
            });
            toast.success("Password reset successfully! You will be redirected to sign in.")
            setTimeout(() => {
                navigate('/signin');
            }, 3000); // 3000 milliseconds = 3 seconds
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong!");
            console.log(err);
        }
    };

    useEffect(() => {
        document.title = "Reset Password - iLead CRM";
    }, [])

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '100vh',
            bgcolor: 'white',

        }}>
            <Toaster richColors />
            <CssBaseline />
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main', mt: '64px' }}>
                <CheckCircleIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Reset Password
            </Typography>

            <Box sx={{
                mt: 1,
                width: '100%', // Make it responsive
                maxWidth: '400px', // Restrict the maximum width
                margin: '0 auto', // Center it horizontally
            }}>
                <form id="resetPassword" onSubmit={handleSubmit}>
                    <TextField
                        sx={{ mt: 2 }}
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                    />
                    <TextField
                        sx={{ mt: 2 }}
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirm Password"
                        type="password"
                        id="confirmPassword"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                    />
                </form>
                <Button
                    type="submit"
                    form="resetPassword"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 2 }}
                >
                    Reset password
                </Button>
            </Box>
            <Copyright sx={{ mt: 5 }} />
        </Box >
    )
}

function Copyright(props) {
    return (
        <Typography variant="body1" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://ilead.swiss/">
                <Logo style={{ width: "45px" }} />
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}


export default ResetPassword;